export class FilterUser {
    e!: string;
    n!: string;
    ps!: string;
    ms!: string;
    ac!: number;
}